<template>
  <v-container fill-height>
    
    <v-row justify="center" align="center">
      <v-btn @click="selectFile" xlarge dark >
        SELECT AN IMAGE !!
      </v-btn>
      <input style="display: none" 
        ref="input" type="file" 
        @change="uploadSelectedFile()">
    </v-row>

  </v-container>
</template>

<script>
import { Auth, Storage } from 'aws-amplify';

export default {
  name: 'Home',
  data: () => ({
    // TODO: add veriables for other environments
    // https://qiita.com/go6887/items/2e254d31b5a4af42f813
    loginid: process.env.VUE_APP_AMPLIFY_LOGIN_ID, 
    loginpw: process.env.VUE_APP_AMPLIFY_LOGIN_PASSWORD, 
  }), 
  mounted: async function() {
    this.login();
  }, 
  methods:{
    login() {
      console.log("login.");
      Auth.signIn(this.loginid, this.loginpw)
        .then((data) => {
          if(data.challengeName == "NEW_PASSWORD_REQUIRED"){
            console.log("new password required.");
            data.completeNewPasswordChallenge(this.loginpw, {}, 
              {
                onSuccess(result) {
                    console.log("onSuccess");
                    console.log(result);
                },
                onFailure(err) {
                    console.log("onFailure");
                    console.log(err);
                }
              }
            );
          }
          console.log("login successfully.");
        }).catch((err) => {
          console.log("login failed.");
          console.log(err);
        });
    },

    selectFile() {
      if(this.$refs.input != undefined){
        this.$refs.input.click();
      }
    }, 

    uploadSelectedFile() {
      let file = this.$refs.input.files[0];
      if(file == undefined){
        return;
      }
      console.log(file);

      let dt = new Date();
      let dirName = this.getDirString(dt);
      let filePath = dirName + "/" + file.name;
      Storage.put(filePath, file).then(result => {
        console.log(result);
      }).catch(err => console.log(err));

      this.$router.push({ path: 'result', query: { group: dirName }}); 
    }, 

    getDirString(date){
      return "" + 
        ("00" + date.getUTCFullYear()).slice(-2) + 
        ("00" + (date.getMonth() + 1)).slice(-2) + 
        ("00" + date.getUTCDate()).slice(-2) + 
        "/" + this.$uuid.v4();
    }, 
  }
}
</script>